import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.replace";
/**
 * Template: Collections List
 * ------------------------------------------------------------------------------
 * Highly coupled scripts to power the collections list page functionality.
 *
 * @namespace listCollections
 */

function collectionsAllRedirect() {
  const pathName = window.location.pathname;

  if (pathName === '/collections/') {
    window.location.pathname = pathName.replace('/collections/', '/collections/all');
  } else {
    window.location.pathname = pathName.replace('/collections', '/collections/all');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  collectionsAllRedirect();
});